import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsDevRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-dev',
	path: '/secure/ConfigureDevStatus.jspa',
	query: ['projectKey'],
};
